<template>
  <responsive-modal v-model="visible" title="Integrar Voxuy">
    <div class="tool-modal-voxuy">
      <a href="https://www.voxuy.com/" target="_blank" class="integration-link">
        Conheça a Voxuy
        <i class="ph ph-arrow-square-out" />
      </a>
      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <snow-select
          :disabled="form.id != null"
          id="product-select"
          label="Produto"
          v-model="form.product_id"
          :options="products.map(({ id, name }) => ({ id, name }))"
        />
      </action-dispatcher>
      <snow-input
        label="Descrição da integração"
        id="description"
        v-model="form.description"
        :rules="rules.description"
        placeholder="Digite a descrição da integração..."
      />
      <action-dispatcher action="integration/getTypeEvents">
        <snow-checkboxes-dropdown
          label="Eventos disparados"
          id="events-select"
          v-model="form.events"
          :options="normalizedTypeEvents"
        />
      </action-dispatcher>
      <snow-input label="URL" id="url" v-model="form.url" :rules="rules.url" />
      <snow-input
        label="Token"
        id="url"
        v-model="form.token"
        :rules="rules.token"
      />
      <snow-input
        label="ID do plano"
        id="internal-id"
        v-model="form.plan_id"
        :rules="rules.plan_id"
      />
      <div class="snow-submit-buttons">
        <snow-button
          size="lg"
          text="Cancelar"
          variant="gray"
          class="order-lg-0 order-1"
          @click="
            visible = false;
            clear();
          "
        />
        <snow-button
          size="lg"
          text="Salvar"
          :disabled="!isValid"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
import { required, validUrl } from "@/functions/validation";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(
        [
          "description",
          "plan_id",
          "status",
          "events",
          "token",
          "url",
          "product_id"
        ],
        {
          events: []
        }
      ),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
        this.form.events = v.events.map(e => e.event);
        this.form.product_id = v.events[0].product_id;
      }
    }
  },
  computed: {
    ...mapState("integration", ["typeEvents"]),
    ...mapState("product", ["products"]),
    isValid() {
      return (
        this.form.events.length &&
        this.form.description &&
        this.form.product_id &&
        this.form.plan_id &&
        this.form.token &&
        this.form.url
      );
    },
    normalizedTypeEvents() {
      return this.typeEvents.map(e => ({
        id: e.id,
        label: e.name
      }));
    },
    rules() {
      return {
        url: [required(), validUrl()],
        description: [required()],
        plan_id: [required()],
        token: [required()]
      };
    }
  },
  methods: {
    clear() {
      this.form = { events: [] };
      this.$emit("clear-edit");
    },
    onSubmit() {
      this.visible = false;
      this.$emit("loading");
      setTimeout(() => {
        this.$emit("update-list");
      }, 5200);
      this.clear();
    },
    submit() {
      this.loading = true;

      this.form.events = this.form.events.map(e => {
        return { event: e };
      });
      const data = {
        ...this.form
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, data)
        .then(() => {
          this.onSubmit();
          this.$message.success("A integração foi salva!");
        })
        .catch(e =>
          this.handleErrors(
            e,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar integração"
          )
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-voxuy {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
